'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getBotResponder = undefined;

var _getIn = require('transmute/getIn');

var _getIn2 = _interopRequireDefault(_getIn);

var _senderTypes = require('conversations-schema/pubnub-message/constants/senderTypes');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getBotResponder = exports.getBotResponder = function getBotResponder(state) {
  return (0, _getIn2.default)(['responders', _senderTypes.BOT], state).first();
};


//////////////////
// WEBPACK FOOTER
// ./js/responders/selectors/getBotResponder.js
// module id = 1058
// module chunks = 2 3